import { get } from "helpers/api_helper";
import * as url from '../url_helper';
import { convertObjectToParams } from "utils";

export const apiGetRecordPatient = ({ id, params = {} }) => {
  return get(`/record/records/patient/${id}`, {
    params,
  });
};

export const apiGetRecordPatientPublic = ({ id, params = {} }) => {
  return get(`/record/records/external/patient/${id}`, {
    params,
  });
};

export const apiExportRecordsPdf = async (patientId, data) => {
  let urlApi = `/record/records/${patientId}/export-pdf-calendar`;
  if (data) {
    const params = convertObjectToParams(data);
    urlApi = urlApi + "?" + params;
  }

  const res = await get(urlApi);
  return res;
};

/**
 *
 * @param {
 *  from: string,
 *  to: string,
 *  patientId: string
 * } params
 * @returns
 */
export const apiExportRecordsCsvManual = async (params) => {
  const res = await get(`/record/records/export-csv-manual`, {
    params,
  });
  return res;
};

/**
 *
 * @param {
 *  from: string,
 *  to: string,
 *  patientId: string
 * } params
 * @returns
 */
export const apiExportRecordsCsvAuto = async (params) => {
  const res = await get(`/record/records/export-csv-auto`, {
    params,
  });
  return res;
};

export const apiExportCSVAllDataForPatient = (id, type) => get(url.API_ADMIN_EXPORT_ALL_DATA_URINE + `?patient_id=${id}&type=${type}`);


export const apiGetChartData = (id, data) => {
  let urlApi = url.API_RECORD_CHART.replace(':id', id);
  if (data) {
    const params = convertObjectToParams(data);
    urlApi = urlApi + "?" + params;
  }
  return get(urlApi);
};


export const apiGetRecordSorted = (id) => {
  let urlApi = url.API_RECORD_SORTED.replace(':id', id);
  return get(urlApi);
};

export const apiGetRecordSortedPublic = (id) => {
  let urlApi = url.API_RECORD_SORTED_PUBLIC.replace(':id', id);
  return get(urlApi);
};
